import { dateComparator } from "utils/comparatorUtils";
import {  getCell, getName } from "utils/insightsAndAlarmsUtils";
import { dateRangeFilter,formatDateLocalTZ } from "utils/utils";
import { INSIGHT_HISTORY_TABLE_STRINGS } from "constants/constantStrings";

export const getInsightListTableConfig = showTableFilterIcon => [
  {
    field: "SystemId",
    headerName: INSIGHT_HISTORY_TABLE_STRINGS.systemId,
    flex: 1.5,
    editable: false,
    filter: showTableFilterIcon
  },
  {
    field: "SystemName",
    headerName: INSIGHT_HISTORY_TABLE_STRINGS.systemName,
    flex: 1.5,
    editable: false,
    filter: showTableFilterIcon
  },
  {
    headerName: INSIGHT_HISTORY_TABLE_STRINGS.insightName,
    flex: 1.5,
    editable: false,
    valueFormatter: getName,
    defaultSort: "desc",
    filter: showTableFilterIcon
  },
  {
    field: "AnomalyType",
    headerName: INSIGHT_HISTORY_TABLE_STRINGS.tagName,
    flex: 1,
    editable: false,
    filter: showTableFilterIcon
  },
  {
    headerName: INSIGHT_HISTORY_TABLE_STRINGS.insightDescription,
    flex: 2.5,
    editable: false,
    valueFormatter: params => getCell(params, "description"),
    filter: showTableFilterIcon
  },
  {
    field: "CycleStartTime",
    headerName: INSIGHT_HISTORY_TABLE_STRINGS.startTime,
    flex: 1.5,
    editable: false,
    filter: showTableFilterIcon,
    valueFormatter: params => formatDateLocalTZ(params.data?.CycleStartTime),
    filter: "agDateColumnFilter",
    filterParams: dateRangeFilter,
    comparator: dateComparator
  },
  {
    field: "CycleEndTime",
    headerName: INSIGHT_HISTORY_TABLE_STRINGS.endTime,
    flex: 1.5,
    editable: false,
    filter: showTableFilterIcon,
    valueFormatter: params => formatDateLocalTZ(params.data?.CycleEndTime),
    filter: "agDateColumnFilter",
    filterParams: dateRangeFilter,
    comparator: dateComparator
  }
];
